const ELEMENT_TYPES = {
  tabs: 'tabs',
  tabs_header: 'tabs_header',
  tabs_header_item: 'tabs_header_item',
  tabs_content_item: 'tabs_content_item',
  code_no_tabs: 'code_no_tabs',
  code_tabs: 'code_tabs',
  code_tabs_header: 'code_tabs_header',
  code_tabs_header_item: 'code_tabs_header_item',
  code_tabs_content_item: 'code_tabs_content_item',
  code_tabs_content_item_line: 'code_tabs_content_item_line',
  raw_markdown: 'raw_markdown',
  unordered_list: 'unordered_list',
  ordered_list: 'ordered_list',
  check_list: 'check_list',
  list_item: 'list_item',
  check_list_item: 'check_list_item',
  header_one: 'header_one',
  header_two: 'header_two',
  header_three: 'header_three',
  default: 'paragraph',
  quote: 'quote',
  quote_content: 'quote_content',
  hint: 'hint',
  hint_content: 'hint_content',
  table: 'table',
  table_thead: 'table_thead',
  table_tbody: 'table_tbody',
  table_tr: 'table_tr',
  table_td: 'table_td',
  table_th: 'table_th',
  math: 'math',
  mermaid: 'mermaid',
  image: 'image',
  file: 'file',
  horizontal_rule: 'horizontal_rule',
  embed: 'embed',
  embed_content: 'embed_content',
  api: 'api',
  api_method_and_title: 'api_method_and_title',
  api_method: 'api_method',
  api_title: 'api_title',
  api_path: 'api_path',
  api_tabs: 'api_tabs',
  api_description: 'api_description',
  api_tabs_header: 'api_tabs_header',
  api_tabs_header_item: 'api_tabs_header_item',
  api_tabs_content_item: 'api_tabs_content_item',
  api_request: 'api_request',
  api_response: 'api_response',
  documentlink: 'documentlink',
  issuelink: 'issuelink',
  mrlink: 'mrlink',
  commitlink: 'commitlink',
  link: 'link',
  emoji: 'emoji',
  alignInitial: 'initial',
  alignLeft: 'left',
  alignRight: 'right',
  alignCenter: 'center',
  alignJustify: 'justify',
  video: 'video',
  audio: 'audio',
  pdf: 'pdf',
  loom: 'loom',
  figma: 'figma',
  gist: 'gist',
  typeform: 'typeform',
  google_drive: 'google_drive',
  swagger: 'swagger',
  graphiql: 'graphiql',
  mention: 'mention'
}

const ELEMENT_TYPES_ARRAY = [
  'tabs',
  'tabs_header',
  'tabs_header_item',
  'tabs_content_item',
  'code_no_tabs',
  'code_tabs',
  'code_tabs_header',
  'code_tabs_header_item',
  'code_tabs_content_item',
  'code_tabs_content_item_line',
  'raw_markdown',
  'unordered_list',
  'ordered_list',
  'check_list',
  'list_item',
  'check_list_item',
  'header_one',
  'header_two',
  'header_three',
  'paragraph',
  'quote',
  'quote_content',
  'hint',
  'hint_content',
  'table',
  'table_thead',
  'table_tbody',
  'table_tr',
  'table_td',
  'table_th',
  'math',
  'mermaid',
  'image',
  'file',
  'horizontal_rule',
  'embed',
  'embed_content',
  'api',
  'api_method_and_title',
  'api_method',
  'api_title',
  'api_path',
  'api_tabs',
  'api_description',
  'api_tabs_header',
  'api_tabs_header_item',
  'api_tabs_content_item',
  'api_request',
  'api_response',
  'documentlink',
  'issuelink',
  'mrlink',
  'commitlink',
  'link',
  'emoji',
  'initial',
  'left',
  'right',
  'center',
  'justify',
  'video',
  'audio',
  'pdf',
  'loom',
  'figma',
  'gist',
  'typeform',
  'google_drive',
  'swagger',
  'graphiql',
  'mention'
]

const LEAF_TYPES = {
  bold: 'bold',
  code: 'code',
  italic: 'italic',
  underlined: 'underlined',
  strikethrough: 'strikethrough',
  superscript: 'superscript',
  subscript: 'subscript',
  mark: 'mark',
  color: 'color'
}

const HINT_TYPES = {
  info: {
    key: 'info',
    color: '#884ffc',
    icon: 'fad fa-info-circle'
  },
  success: {
    key: 'success',
    color: '#3ecf8e',
    icon: 'fad fa-check-circle'
  },
  warning: {
    key: 'warning',
    color: '#fb9e00',
    icon: 'fad fa-exclamation-circle'
  },
  danger: {
    key: 'danger',
    color: '#f53016',
    icon: 'fad fa-exclamation-triangle'
  }
}

const HINT_TYPES_BY_KEY = ['info', 'success', 'warning', 'danger']

const VOID_TYPES = [
  ELEMENT_TYPES.horizontal_rule,
  ELEMENT_TYPES.file,
  ELEMENT_TYPES.image,
  ELEMENT_TYPES.embed,
  ELEMENT_TYPES.math,
  ELEMENT_TYPES.mermaid,
  ELEMENT_TYPES.swagger,
  ELEMENT_TYPES.graphiql,
  ELEMENT_TYPES.video,
  ELEMENT_TYPES.audio,
  ELEMENT_TYPES.pdf,
  ELEMENT_TYPES.loom,
  ELEMENT_TYPES.figma,
  ELEMENT_TYPES.gist,
  ELEMENT_TYPES.typeform,
  ELEMENT_TYPES.google_drive,
  ELEMENT_TYPES.documentlink,
  ELEMENT_TYPES.issuelink,
  ELEMENT_TYPES.commitlink,
  ELEMENT_TYPES.mrlink
]

const MARKDOWN_ELEMENTS = {
  '*': ELEMENT_TYPES.unordered_list,
  '-': ELEMENT_TYPES.unordered_list,
  '+': ELEMENT_TYPES.unordered_list,
  '1.': ELEMENT_TYPES.ordered_list,
  '[x]': ELEMENT_TYPES.check_list,
  '>': ELEMENT_TYPES.quote,
  '#': ELEMENT_TYPES.header_one,
  '##': ELEMENT_TYPES.header_two,
  '###': ELEMENT_TYPES.header_three,
  '```': ELEMENT_TYPES.code_tabs,
  '***': ELEMENT_TYPES.horizontal_rule,
  '---': ELEMENT_TYPES.horizontal_rule
}

const MARKDOWN_INLINES_CHECK = ['*', '_', '`', '~', ')']

const API_METHOD_TYPES = {
  get: {
    label: 'get',
    color: '#009CE0'
  },
  post: {
    label: 'post',
    color: '#2DC6C3'
  },
  put: {
    label: 'put',
    color: '#FB9E00'
  },
  delete: {
    label: 'delete',
    color: '#F44E3B'
  },
  patch: {
    label: 'patch',
    color: '#838383'
  },
  head: {
    label: 'head',
    color: '#884ffc'
  },
  options: {
    label: 'options',
    color: '#997a0e'
  },
  trace: {
    label: 'trace',
    color: '#009CE0'
  }
}

const paragraph = {
  label: 'Paragraph',
  type: ELEMENT_TYPES.default,
  icon: 'far fa-paragraph'
}

const header_one = {
  label: 'Header One',
  type: ELEMENT_TYPES.header_one,
  icon: 'far fa-h1'
}

const header_two = {
  label: 'Header Two',
  type: ELEMENT_TYPES.header_two,
  icon: 'far fa-h2'
}

const header_three = {
  label: 'Header Three',
  type: ELEMENT_TYPES.header_three,
  icon: 'far fa-h3'
}

const unordered_list = {
  label: 'Bulleted List',
  type: ELEMENT_TYPES.unordered_list,
  icon: 'far fa-list-ul'
}

const ordered_list = {
  label: 'Ordered List',
  type: ELEMENT_TYPES.ordered_list,
  icon: 'far fa-list-ol'
}

const check_list = {
  label: 'Check List',
  type: ELEMENT_TYPES.check_list,
  icon: 'far fa-tasks'
}

const horizontal_rule = {
  label: 'Horizontal Rule',
  type: ELEMENT_TYPES.horizontal_rule,
  icon: 'far fa-horizontal-rule'
}

const code_no_tabs = {
  label: 'Code',
  type: ELEMENT_TYPES.code_no_tabs,
  icon: 'far fa-brackets-curly'
}

const code_tabs = {
  label: 'Code',
  type: ELEMENT_TYPES.code_tabs,
  icon: 'far fa-brackets-curly'
}

const quote = {
  label: 'Quote',
  type: ELEMENT_TYPES.quote,
  icon: 'far fa-quote-left'
}

const image = {
  label: 'Image',
  type: ELEMENT_TYPES.image,
  upload: true,
  icon: 'far fa-image'
}

const embed = {
  label: 'Embed Code',
  type: ELEMENT_TYPES.embed,
  placeholder: 'Paste Embed Code',
  embed_code: true,
  icon: 'far fa-code'
}

const video = {
  label: 'Video',
  type: ELEMENT_TYPES.video,
  embed_code: false,
  placeholder: 'Add vimeo, youtube, twitch, facebook video links or a link to a video file',
  icon: 'fab fa-youtube'
}

const audio = {
  label: 'Audio',
  type: ELEMENT_TYPES.audio,
  embed_code: false,
  placeholder: 'Add soundcloud, mixcloud, or a link to an audio file',
  icon: 'far fa-waveform'
}

const pdf = {
  label: 'PDF',
  embed_code: false,
  type: ELEMENT_TYPES.pdf,
  placeholder: 'Enter link to a PDF file',
  icon: 'far fa-file-pdf'
}

const loom = {
  label: 'Loom',
  embed_code: false,
  type: ELEMENT_TYPES.loom,
  placeholder: 'Enter Loom share url',
  icon: 'far fa-video'
}

const figma = {
  label: 'Figma',
  embed_code: false,
  type: ELEMENT_TYPES.figma,
  placeholder: 'Enter Figma File URL',
  icon: 'fab fa-figma'
}

const gist = {
  label: 'Github Gist',
  embed_code: false,
  type: ELEMENT_TYPES.gist,
  placeholder: 'Enter Github Gist URL',
  icon: 'fab fa-github',
  responsiveEmbedDisabled: true,
  aspectDisabled: true
}

const typeform = {
  label: 'Typeform',
  type: ELEMENT_TYPES.typeform,
  placeholder: 'Enter Typeform URL',
  icon: 'far fa-text'
}

const google_drive = {
  label: 'Google Drive',
  embed_code: false,
  type: ELEMENT_TYPES.google_drive,
  placeholder: 'Enter share URL to any Google Drive item',
  icon: 'fab fa-google-drive'
}

const table = {
  label: 'Table',
  type: ELEMENT_TYPES.table,
  icon: 'far fa-table'
}

const hint = {
  label: 'Callout',
  type: ELEMENT_TYPES.hint,
  icon: 'far fa-exclamation-circle'
}

const api = {
  label: 'API Method',
  type: ELEMENT_TYPES.api,
  icon: 'far fa-sync-alt'
}

const api_request = {
  label: 'Add Request',
  type: ELEMENT_TYPES.api_request,
  icon: 'far fa-share'
}

const api_response = {
  label: 'Add Response',
  type: ELEMENT_TYPES.api_response,
  icon: 'far fa-reply'
}

const tabs = {
  label: 'Tabs',
  type: ELEMENT_TYPES.tabs,
  icon: 'far fa-browser'
}

const file = {
  label: 'File',
  type: ELEMENT_TYPES.file,
  upload: true,
  icon: 'far fa-paperclip'
}

const math = {
  label: 'Math',
  type: ELEMENT_TYPES.math,
  icon: 'far fa-function'
}

const mermaid = {
  label: 'Mermaid Diagram',
  type: ELEMENT_TYPES.mermaid,
  icon: 'far fa-project-diagram'
}

const documentlink = {
  label: 'Document',
  type: ELEMENT_TYPES.documentlink,
  icon: 'far fa-file-contract',
  filter: 'DOCUMENTS'
}

const issuelink = {
  label: 'Issue',
  type: ELEMENT_TYPES.issuelink,
  icon: 'far fa-tasks',
  filter: 'ISSUES'
}

const commitlink = {
  label: 'Commit',
  type: ELEMENT_TYPES.commitlink,
  icon: 'far fa-code-commit',
  filter: 'COMMITS'
}

const mrlink = {
  label: 'Merge Request',
  type: ELEMENT_TYPES.mrlink,
  icon: 'far fa-code-pull-request',
  filter: 'MERGE_REQUESTS'
}

const swagger = {
  label: 'Open AI/Swagger API',
  type: ELEMENT_TYPES.swagger,
  icon: 'far fa-brackets-curly'
}

const graphiql = {
  label: 'GraphiQL',
  type: ELEMENT_TYPES.graphiql,
  icon: 'far fa-hexagon'
}

const ELEMENT_TYPES_BY_KEY = {}
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.default] = paragraph
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.header_one] = header_one
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.header_two] = header_two
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.header_three] = header_three
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.unordered_list] = unordered_list
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.ordered_list] = ordered_list
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.check_list] = check_list
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.horizontal_rule] = horizontal_rule
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.code_no_tabs] = code_no_tabs
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.code_tabs] = code_tabs
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.quote] = quote
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.image] = image
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.embed] = embed
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.video] = video
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.audio] = audio
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.pdf] = pdf
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.loom] = loom
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.figma] = figma
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.gist] = gist
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.typeform] = typeform
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.google_drive] = google_drive
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.table] = table
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.hint] = hint
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.api] = api
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.tabs] = tabs
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.file] = file
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.math] = math
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.mermaid] = mermaid
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.swagger] = swagger
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.graphiql] = graphiql
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.documentlink] = documentlink
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.issuelink] = issuelink
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.commitlink] = commitlink
ELEMENT_TYPES_BY_KEY[ELEMENT_TYPES.mrlink] = mrlink

const NEW_ELEMENT_MENU_ITEMS = [
  {
    label: 'Basic',
    options: [
      { ...header_one },
      { ...header_two },
      { ...header_three },
      { ...unordered_list },
      { ...ordered_list },
      { ...check_list },
      { ...horizontal_rule },
      { ...quote },
      { ...table },
      { ...hint },
      { ...tabs }
    ]
  },
  {
    label: 'Upload',
    options: [{ ...image }, { ...file }]
  },
  {
    label: 'Link To A Page',
    options: [{ ...documentlink }, { ...issuelink }, { ...mrlink }, { ...commitlink }]
  },
  {
    label: 'Embed',
    options: [
      { ...embed },
      { ...video },
      { ...audio },
      { ...pdf },
      { ...loom },
      { ...figma },
      { ...gist },
      { ...typeform },
      { ...google_drive }
    ]
  },
  {
    label: 'Technical',
    options: [{ ...code_tabs }, { ...api }, { ...math }, { ...mermaid }, { ...swagger }, { ...graphiql }]
  }
]

const TOOLBAR_EXCLUDES = [
  ELEMENT_TYPES.tabs_header_item,
  ELEMENT_TYPES.api_tabs_header_item,
  ELEMENT_TYPES.math,
  ELEMENT_TYPES.mermaid,
  ELEMENT_TYPES.swagger,
  ELEMENT_TYPES.graphiql,
  ELEMENT_TYPES.embed_content,
  ELEMENT_TYPES.code_no_tabs,
  ELEMENT_TYPES.code_tabs_header_item,
  ELEMENT_TYPES.code_tabs_content_item,
  ELEMENT_TYPES.code_tabs_content_item_line,
  ELEMENT_TYPES.raw_markdown
]

const VALID_COMMENT_TYPES = [ELEMENT_TYPES.default]

const EXISTING_ELEMENT_MENU_ITEMS = {}

EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.default] = {
  items: [{ label: 'Basic', options: [{ ...paragraph }, { ...header_one }, { ...header_two }, { ...header_three }] }]
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.header_one] = {
  items: [
    {
      label: 'Basic',
      options: [{ ...paragraph }, { ...header_one }, { ...header_two }, { ...header_three }]
    }
  ]
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.header_two] = {
  items: [
    {
      label: 'Basic',
      options: [{ ...paragraph }, { ...header_one }, { ...header_two }, { ...header_three }]
    }
  ]
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.header_three] = {
  items: [
    {
      label: 'Basic',
      options: [{ ...paragraph }, { ...header_one }, { ...header_two }, { ...header_three }]
    }
  ]
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.unordered_list] = {
  items: [
    {
      label: 'Basic',
      options: [{ ...unordered_list }, { ...ordered_list }, { ...check_list }]
    }
  ]
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.ordered_list] = {
  items: [
    {
      label: 'Basic',
      options: [{ ...unordered_list }, { ...ordered_list }, { ...check_list }]
    }
  ]
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.check_list] = {
  items: [{ label: 'Basic', options: [{ ...unordered_list }, { ...ordered_list }, { ...check_list }] }]
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.tabs] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.code_no_tabs] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.code_tabs] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.raw_markdown] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.quote] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.hint] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.table] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.math] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.mermaid] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.swagger] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.graphiql] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.image] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.file] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.horizontal_rule] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.embed] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.video] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.audio] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.pdf] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.loom] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.figma] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.gist] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.typeform] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.google_drive] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.api] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.documentlink] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.issuelink] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.mrlink] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS[ELEMENT_TYPES.commitlink] = {
  items: []
}

const EXISTING_ELEMENT_MENU_ITEMS_BY_KEY = {}

EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.default] = {
  items: [paragraph.type, header_one.type, header_two.type, header_three.type]
}

EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.header_one] = {
  items: [paragraph.type, header_one.type, header_two.type, header_three.type]
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.header_two] = {
  items: [paragraph.type, header_one.type, header_two.type, header_three.type]
}

EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.header_three] = {
  items: [paragraph.type, header_one.type, header_two.type, header_three.type]
}

EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.unordered_list] = {
  items: [unordered_list.type, ordered_list.type, check_list.type]
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.ordered_list] = {
  items: [unordered_list.type, ordered_list.type, check_list.type]
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.check_list] = {
  items: [unordered_list.type, ordered_list.type, check_list.type]
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.tabs] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.code_no_tabs] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.code_tabs] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.raw_markdown] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.quote] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.hint] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.table] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.math] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.mermaid] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.swagger] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.graphiql] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.image] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.file] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.horizontal_rule] = {
  items: []
}
EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.embed] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.video] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.audio] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.pdf] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.loom] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.figma] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.gist] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.typeform] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.google_drive] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.api] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.documentlink] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.issuelink] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.mrlink] = {
  items: []
}

EXISTING_ELEMENT_MENU_ITEMS_BY_KEY[ELEMENT_TYPES.commitlink] = {
  items: []
}

const NEW_CHILD_ELEMENT_MENU_ITEMS = {
  tabs_content_item: {
    valid_items: [
      ELEMENT_TYPES.default,
      ELEMENT_TYPES.header_one,
      ELEMENT_TYPES.header_two,
      ELEMENT_TYPES.header_three,
      ELEMENT_TYPES.unordered_list,
      ELEMENT_TYPES.ordered_list,
      ELEMENT_TYPES.check_list,
      ELEMENT_TYPES.horizontal_rule,
      ELEMENT_TYPES.code_tabs,
      ELEMENT_TYPES.quote,
      ELEMENT_TYPES.image,
      ELEMENT_TYPES.embed,
      ELEMENT_TYPES.video,
      ELEMENT_TYPES.audio,
      ELEMENT_TYPES.pdf,
      ELEMENT_TYPES.loom,
      ELEMENT_TYPES.figma,
      ELEMENT_TYPES.gist,
      ELEMENT_TYPES.typeform,
      ELEMENT_TYPES.google_drive,
      ELEMENT_TYPES.table,
      ELEMENT_TYPES.hint,
      ELEMENT_TYPES.file,
      ELEMENT_TYPES.math,
      ELEMENT_TYPES.mermaid,
      ELEMENT_TYPES.swagger,
      ELEMENT_TYPES.graphiql,
      ELEMENT_TYPES.default
    ],
    items: [
      {
        label: 'Basic',
        options: [
          { ...paragraph },
          { ...header_one },
          { ...header_two },
          { ...header_three },
          { ...unordered_list },
          { ...ordered_list },
          { ...check_list },
          { ...horizontal_rule },
          { ...quote },
          { ...table },
          { ...hint }
        ]
      },
      {
        label: 'Link To A Page',
        options: [{ ...documentlink }, { ...issuelink }, { ...mrlink }, { ...commitlink }]
      },
      {
        label: 'Embed',
        options: [
          { ...embed },
          { ...video },
          { ...audio },
          { ...pdf },
          { ...loom },
          { ...figma },
          { ...gist },
          { ...typeform },
          { ...google_drive }
        ]
      },
      {
        label: 'Upload',
        options: [{ ...image }, { ...file }]
      },
      {
        label: 'Technical',
        options: [{ ...code_tabs }, { ...math }, { ...mermaid }, { ...swagger }, { ...graphiql }]
      }
    ]
  },
  api_tabs_content_item: {
    no_line_breaks: true,
    min_children: 1,
    valid_items: [ELEMENT_TYPES.api_request, ELEMENT_TYPES.api_response],
    items: [
      {
        label: 'Api',
        options: [{ ...api_request }, { ...api_response }]
      }
    ]
  },
  quote_content: {
    valid_items: [ELEMENT_TYPES.header_one, ELEMENT_TYPES.header_two, ELEMENT_TYPES.header_three, ELEMENT_TYPES.default],
    items: [
      {
        label: 'Basic',
        options: [{ ...paragraph }, { ...header_one }, { ...header_two }, { ...header_three }]
      },
      {
        label: 'Link To A Page',
        options: [{ ...documentlink }, { ...issuelink }, { ...mrlink }, { ...commitlink }]
      }
    ]
  },
  hint_content: {
    valid_items: [
      ELEMENT_TYPES.header_one,
      ELEMENT_TYPES.header_two,
      ELEMENT_TYPES.header_three,
      ELEMENT_TYPES.unordered_list,
      ELEMENT_TYPES.ordered_list,
      ELEMENT_TYPES.check_list,
      ELEMENT_TYPES.default
    ],
    items: [
      {
        label: 'Basic',
        options: [
          { ...paragraph },
          { ...header_one },
          { ...header_two },
          { ...header_three },
          { ...unordered_list },
          { ...ordered_list },
          { ...check_list }
        ]
      },
      {
        label: 'Link To A Page',
        options: [{ ...documentlink }, { ...issuelink }, { ...mrlink }, { ...commitlink }]
      }
    ]
  }
}

export {
  ELEMENT_TYPES,
  ELEMENT_TYPES_BY_KEY,
  ELEMENT_TYPES_ARRAY,
  HINT_TYPES,
  HINT_TYPES_BY_KEY,
  API_METHOD_TYPES,
  LEAF_TYPES,
  NEW_ELEMENT_MENU_ITEMS,
  VALID_COMMENT_TYPES,
  EXISTING_ELEMENT_MENU_ITEMS,
  EXISTING_ELEMENT_MENU_ITEMS_BY_KEY,
  NEW_CHILD_ELEMENT_MENU_ITEMS,
  VOID_TYPES,
  TOOLBAR_EXCLUDES,
  MARKDOWN_ELEMENTS,
  MARKDOWN_INLINES_CHECK
}
